const useComponent = ({ departments, setDepartments }) => {
  const thereIsComponent = (data, index) => data[index];

  return {
    thereIsComponent,
  };
};

export default useComponent;
